
import slugify from "slugify";

export const convertApiToNavData = (apiResponse, t = (k) => k, language = "tr") => {
  if (!apiResponse?.docSearchList) return [];

  const root = {
    id: "root",
    title: t("İÇİNDEKİLER"),
    childs: [],
  };

  const findOrCreateNode = (parent, title) => {
    let node = parent.childs.find((c) => c.title === title);
    if (!node) {
      node = {
        id: slugify(title, { lower: true, strict: true }),
        title,
        childs: [],
      };
      parent.childs.push(node);
    }
    return node;
  };

  apiResponse.docSearchList.forEach((group) => {
    const pathSegments = (group.groupLabelPath || "")
      .split("/")
      .filter(Boolean)
      .map((seg) => t(seg.trim()));

    let currentNode = root;
    for (const segment of pathSegments) {
      currentNode = findOrCreateNode(currentNode, segment);
    }

    (group.docList || []).forEach((doc) => {
      const rawTitle = doc?.description?.subject?.trim() ?? t("Bilinmeyen Başlık");
      const title = t(rawTitle);

      currentNode.childs.push({
        id: `${group.groupCode}-${doc?.id || "unknown"}`,
        title,
        uuid: doc.uuid,
      });
    });
  });

  return [root];
};


